import { defineComponent as _defineComponent } from 'vue';
import { SGroup, SImageLazy } from '@strana-artw/ui-kit';
import { computed, defineComponent } from 'vue';
import IconLandingPartnerSliderArrow from '@/shared/ui/icons/IconLandingPartnerSliderArrow.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'LandingPartnerSlider',
  props: {
    items: null
  },
  setup: function setup(__props) {
    defineComponent({
      name: 'LandingPartnerSlider'
    });
    var swiperOptions = computed(function () {
      return {
        speed: 1000,
        slidesPerView: 'auto',
        spaceBetween: 22,
        fadeEffect: {
          crossFade: true
        },
        allowTouchMove: true,
        direction: 'horizontal',
        watchSlidesProgress: true,
        navigation: {
          prevEl: '.btn-prev',
          nextEl: '.btn-next',
          hiddenClass: 'is-hidden',
          disabledClass: 'is-disabled'
        },
        pagination: {
          el: '.pagination-line',
          type: 'progressbar',
          clickable: true
        },
        breakpoints: {
          0: {
            spaceBetween: 16
          },
          1024: {
            spaceBetween: 22
          }
        }
      };
    });
    return {
      __sfc: true,
      swiperOptions: swiperOptions,
      SGroup: SGroup,
      SImageLazy: SImageLazy,
      IconLandingPartnerSliderArrow: IconLandingPartnerSliderArrow
    };
  }
});